<template>
  <v-container fluid class="pa-0 ma-0">
    <v-row class="pa-0 ma-0">
      <v-col
        class="pa-0 ma-0"
        cols="auto"
        v-for="(bc, index) in breadcrumbArray"
        :key="index"
        @click="handleBreadcrumbClick(bc, $event)"
        @mousedown.middle="openBreadcrumbInNewTab(bc, $event)"
      >
        <span style="cursor: pointer" v-if="bc != ''">
          <span v-if="$t('routes.' + bc) != 'routes.' + bc">
            {{ $t("routes." + bc) }}
          </span>
          <span v-else>
            <span v-if="bc == getShortString(bc)">{{ bc }}</span>
            <span v-else
              ><v-tooltip :text="bc">
                <template v-slot:activator="{ props }">
                  <span v-bind="props"> {{ getShortString(bc) }}</span>
                </template>
              </v-tooltip>
            </span>
          </span>

          <v-icon
            v-if="index != breadcrumbArray.length - 1"
            icon="mdi-chevron-right"
          ></v-icon>
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "breadcrumbs",

  data() {
    return {};
  },

  computed: {
    breadcrumbLength() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 25;
        case "lg":
          return 40;
        case "xl":
          return 45;
        case "xxl":
          return 12;
        default:
          return 12;
      }
    },
    breadcrumbArray() {
      let pathSplit = this.$route.matched[this.$route.matched.length - 1].path.split("/");
      for (let i = 0; i < pathSplit.length; i++) {
        if (pathSplit[i].startsWith(":")) {
          //parameters
          let key = pathSplit[i].replace(/[?:]/g, ""); //paramters (:) and optional ones (?)
          if (this.activeElem[key]) {
            pathSplit[i] = this.activeElem[key];
          }
        }
      }

      if (pathSplit && pathSplit.length > 0) {
        let lastElem = pathSplit[pathSplit.length - 1];
        if (lastElem.startsWith(":") && lastElem[lastElem.length - 1] == "?") {
          pathSplit.pop();
        }
      }

      return pathSplit;
    },
    activeElem() {
      return this.$store.state.activeElem || {};
    },
  },

  methods: {
    getShortString(breadcrumb) {
      if (breadcrumb.length > this.breadcrumbLength) {
        return breadcrumb.substring(0, this.breadcrumbLength - 2) + "..";
      }

      return breadcrumb;
    },
    getBreadcrumRoute(breadcrumb) {
      if (breadcrumb == parseInt(breadcrumb)) return;

      let temp = this.$route.path.split("/");
      let nextRoute = "";

      for (let i = 0; i < temp.length; i++) {
        if (temp[i] == breadcrumb) {
          nextRoute += temp[i];

          try {
            if (this.breadcrumbArray[i + 2] == parseInt(this.breadcrumbArray[i + 2])) {
              nextRoute += "/";
              nextRoute += temp[i + 1];
            }
          } catch (e) {
            console.log("rerouting.", e);
          }

          break;
        }

        nextRoute += temp[i] + "/";
      }

      //check if router has to be rerouted to child
      for (let i = 0; i < this.$route.matched.length; i++) {
        if (this.$route.matched[i].path == nextRoute) {
          if (
            this.$route.matched[i].props &&
            this.$route.matched[i].props.default.rerouteToChild
          ) {
            nextRoute += "/" + this.$route.matched[i].children[0].path;
          }

          break;
        }
      }

      nextRoute = nextRoute.replaceAll("//", "/");

      return nextRoute;
    },
    handleBreadcrumbClick(breadcrumb, event) {
      this.$router.push(this.getBreadcrumRoute(breadcrumb));
    },
    openBreadcrumbInNewTab(breadcrumb, event) {
      window.open(this.getBreadcrumRoute(breadcrumb), "_blank");
    },
  },
};
</script>
